import FadeIn from '../components/FadeIn';

function Renderings() {
    return (
        <>
                <title>3D Renderings & Visualization Services - vidi3D</title>
                <meta name="description" content="Transform your vision with vidi3D's photorealistic 3D rendering services. From architectural visualizations to interior design concepts, we bring ideas to life with stunning detail." />
                <meta name="keywords" content="3D renderings, architectural visualization, interior design, photorealistic rendering, 3D modeling" />
                <meta property="og:title" content="3D Renderings & Visualization Services - vidi3D" />
                <meta property="og:description" content="Experience stunning photorealistic 3D renderings that bring your architectural and interior design concepts to life with precision and artistry." />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/renderings/interior-rendering.png`} />
                <link rel="canonical" href="https://vidi3d.com/renderings" />
        <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
            <FadeIn>
            <h1 className="text-6xl font-bold text-brand text-center py-10">Transform your vision into stunning 3D renderings</h1>
            </FadeIn>
            <FadeIn delay={0.25}>
                <p className="text-brand-dark text-center text-xl">Transform your space into photorealistic 3D renderings with our cutting-edge technology and expert design team. From architectural visualizations to interior design concepts, we bring your ideas to life with stunning detail and precision.</p>
            </FadeIn>

            {/* Interior 3D Renderings Section */}
            <div className="w-full mt-12">
                <FadeIn delay={0.25}>
                <div className="relative w-full h-[400px]">
                    <img 
                        src={`${process.env.PUBLIC_URL}/renderings/interior-rendering.jpg`}
                        alt="Interior 3D renderings"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">interior 3D renderings</h2>
                    </div>
                </div>
                </FadeIn>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <FadeIn delay={0.15}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Showcase Unique Pieces</h3>
                            <p className="text-gray-600">Add character to your virtual space with custom 3D models of signature furniture and decor</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.3}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12 5V3M12 21V19M5 12H3M21 12H19M18.364 18.364L16.95 16.95M7.05 7.05L5.636 5.636M18.364 5.636L16.95 7.05M7.05 16.95L5.636 18.364" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Capture Every Detail</h3>
                            <p className="text-gray-600">From texture to form, our models are crafted with precision to reflect the true beauty of each piece</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.45}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M19.4 15C19.1277 15.6171 19.0989 16.3081 19.3186 16.9443C19.5382 17.5805 19.9933 18.1159 20.6 18.4L19.9 19.7C19.2933 19.4159 18.5989 19.3382 17.9386 19.4782C17.2783 19.6182 16.6935 19.9672 16.3 20.4636C15.9065 19.9672 15.3217 19.6182 14.6614 19.4782C14.0011 19.3382 13.3067 19.4159 12.7 19.7L12 18.4C12.6067 18.1159 13.0618 17.5805 13.2814 16.9443C13.5011 16.3081 13.4723 15.6171 13.2 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Personalize Your Space</h3>
                            <p className="text-gray-600">Let your clients experience a space that feels authentic and unique to your venue's personality</p>
                        </div>
                        </FadeIn>
                    </div>
                    <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                    </FadeIn>
                </div>
            </div>

            {/* Layout Setup Customization Section */}
            <div className="w-full mt-12">
                <FadeIn delay={0.25}>
                <div className="relative w-full h-[400px]">
                    <img 
                        src={`${process.env.PUBLIC_URL}/renderings/layout-custom.jpg`}
                        alt="Layout setup customization"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">layout setup customization</h2>
                    </div>
                </div>
                </FadeIn>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <FadeIn delay={0.15}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Multiple Setups, One Space</h3>
                                <p className="text-gray-600">Show your venue's adaptability with a range of layout options tailored to different events</p>
                            </div>
                        </FadeIn>

                        <FadeIn delay={0.3}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21H5M19 21H21M5 21H3M9 6.99998H15M9 11H15M9 15H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Flexible Configurations</h3>
                            <p className="text-gray-600">From formal gatherings to casual setups, give clients a glimpse of endless possibilities</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.45}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Simplify Decision-Making</h3>
                            <p className="text-gray-600">Help clients find the ideal layout by letting them visualize every option upfront</p>
                        </div>
                        </FadeIn>
                    </div>

                    <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                    </FadeIn>
                </div>
            </div>

            {/* Custom Furniture Modeling Section */}
            <div className="w-full mt-12">
                <FadeIn delay={0.25}>
                <div className="relative w-full h-[400px]">
                    <img 
                        src={`${process.env.PUBLIC_URL}/renderings/furniture-custom.jpg`}
                        alt="Custom furniture modeling"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">custom furniture modeling</h2>
                    </div>
                </div>
                </FadeIn>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <FadeIn delay={0.15}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Maximize Your Venue's Potential</h3>
                                <p className="text-gray-600">Our expert guidance ensures your space layout optimizes flow and functionality</p>
                            </div>
                        </FadeIn>

                        <FadeIn delay={0.3}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12 3V7M12 17V21M3 12H7M17 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Design for Impact</h3>
                            <p className="text-gray-600">From concept to completion, we help you craft a space that impresses from every angle</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.45}>

                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Future-Proof Your Venue</h3>
                                <p className="text-gray-600">Plan spaces that evolve with your business and meet the changing needs of your clients</p>
                            </div>
                        </FadeIn>
                    </div>
                    <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                    </FadeIn>
                </div>
            </div>

            {/* Creative Consultancy Section */}
            <div className="w-full mt-12">
                <FadeIn delay={0.25}>
                <div className="relative w-full h-[400px]">
                    <img 
                        src={`${process.env.PUBLIC_URL}/renderings/consulting.jpg`}
                        alt="Creative consultancy"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">creative consultancy</h2>
                    </div>
                </div>
                </FadeIn>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <FadeIn delay={0.15}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7M15 3L19 7M15 3V7H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Photorealistic Quality</h3>
                            <p className="text-gray-600">Experience lifelike renderings that bring out every detail of your venue's design</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.3}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 16L3 12M3 12L7 8M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Elevate Client Presentations</h3>
                            <p className="text-gray-600">Showcase your venue in stunning clarity with visuals that leave a lasting impression</p>
                        </div>
                        </FadeIn>

                        <FadeIn delay={0.45}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Capture Every Angle</h3>
                            <p className="text-gray-600">Our renderings reveal your space's beauty from every perspective, making it easy to showcase online</p>
                        </div>
                        </FadeIn>
                    </div>
                    <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                    </FadeIn>
                </div>
            </div>
        </div>
        </>
    );
  }
  
  export default Renderings;